// extracted by mini-css-extract-plugin
export default {"wrapper":"E2-z","play":"F2-z"};